import { AuthContextLoginParams } from '../models/auth';

export class MessageService {
  private static LOGOUT_EVENT_MESSAGE_KEY = 'asc-logout-event-message';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static logoutMessageListener: any;

  private static REFRESH_TOKENS_MESSAGE_KEY =
    'asc-refresh-tokens-event-message';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static refreshTokensMessageListener: any;

  private static LOGIN_FROM_CHILD_EVENT_MESSAGE_KEY =
    'asc-login-from-child-event-message';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static loginOpenerMessageListener: any;

  public static requestLogout(redirect: string | boolean = false) {
    if (typeof window === 'undefined') return;
    window.postMessage(
      { message: this.LOGOUT_EVENT_MESSAGE_KEY, redirect },
      window.location.origin
    );
  }

  public static requestRefreshTokens(tokens: {
    accessToken: string;
    refreshToken: string;
  }) {
    if (typeof window === 'undefined') return;
    window.postMessage(
      { message: this.REFRESH_TOKENS_MESSAGE_KEY, tokens },
      window.location.origin
    );
  }

  public static requestLoginFromChild(loginParams: AuthContextLoginParams) {
    if (typeof window === 'undefined') return;
    window.opener.postMessage(
      { message: this.LOGIN_FROM_CHILD_EVENT_MESSAGE_KEY, loginParams },
      '*'
    );
  }

  public static addRequestLogoutEventListener<T>(
    logoutHandler: (redirect: T) => void
  ) {
    if (typeof window === 'undefined') return;
    this.logoutMessageListener = window.addEventListener('message', (event) => {
      if (event?.data?.message === this.LOGOUT_EVENT_MESSAGE_KEY) {
        logoutHandler(event?.data?.redirect as T);
      }
    });
  }

  public static addRequestRefreshTokensEventListener<T>(
    refreshTokensHandler: (tokens: T) => void
  ) {
    if (typeof window === 'undefined') return;
    this.refreshTokensMessageListener = window.addEventListener(
      'message',
      (event) => {
        if (event?.data?.message === this.REFRESH_TOKENS_MESSAGE_KEY) {
          refreshTokensHandler(event?.data?.tokens as T);
        }
      }
    );
  }

  public static addRequestLoginFromChildEventListener(
    loginHandler: (loginParams: AuthContextLoginParams) => void
  ) {
    if (typeof window === 'undefined') return;
    this.loginOpenerMessageListener = window.addEventListener(
      'message',
      (event) => {
        if (event?.data?.message === this.LOGIN_FROM_CHILD_EVENT_MESSAGE_KEY) {
          loginHandler(event?.data?.loginParams);
        }
      }
    );
  }

  //TODO: check if the listener is removed correctly
  public static removeRequestLogoutEventListener() {
    if (typeof window === 'undefined') return;
    window.removeEventListener('message', this.logoutMessageListener);
  }

  //TODO: check if the listener is removed correctly
  public static removeRequestRefreshTokensEventListener() {
    if (typeof window === 'undefined') return;
    window.removeEventListener('message', this.refreshTokensMessageListener);
  }
  //TODO: check if the listener is removed correctly
  public static removeRequestLoginFromChildEventListener() {
    if (typeof window === 'undefined') return;
    window.removeEventListener('message', this.loginOpenerMessageListener);
  }
}
